<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';

	import type { Notification } from './store.svelte';

	const { ...rest }: Notification & HTMLAttributes<HTMLDivElement> = $props();

	const notificationClassMap: Record<Notification['type'], string> = {
		info: 'bg-blue-100 text-blue-800',
		success: 'bg-green-100 text-green-800',
		error: 'bg-red-100 text-red-800',
		warning: 'bg-yellow-100 text-yellow-800',
	};
</script>

<div
	class={[
		'mb-2 rounded-md p-2',
		notificationClassMap[rest.type] ?? 'bg-gray-100 text-gray-800',
		rest?.class,
	]}
>
	{rest.message}
</div>
